import React, { useEffect } from "react";

import AssesseeInformationSesion from "../molekuls/AssesseeInformationSesion";
import KonselingInformationSession from "../molekuls/KonselingInformationSession";
import KesimpulanSaranSession from "../molekuls/KesimpulanSaranSession";
import VideoKonselingSession from "../molekuls/VideoKonselingSession";
import VideoKonselingClose from "../molekuls/VideoKonselingClose";
import OtherSecctionData from "../molekuls/OtherSecctionData";
import useValidationDataKonselor from "../../costumeHooks/useValidationDataKonselor";
import useSessionDataPduli from "../../costumeHooks/useSessionDataPduli";
import KonselorInformationSession from "../molekuls/KonselorInformationSession";
import VideoKonselingWatingOpen from "../molekuls/VideoKonselingWatingOpen";

export default function PartSessionKonseling() {
  const { dataValidationUser } = useValidationDataKonselor();
  const {
    loading,
    dataSessionPduli,
    isWaitingRoom,
    isRoomClose,
    isRoomOpen,
    roomStatus,
    forceClose,
    handleOpenRoom,
    handleCLoseRoom,
    handleCLoseRoomByServer,
    handleForceCloseRoom,
    handleStartRecord,
    handleReGetData,
  } = useSessionDataPduli({
    sessionId: dataValidationUser?.data?.session,
  });

  return (
    <>
      <div className="flex bg-black">
        <div className="hidden sm:flex flex-col flex-1 p-2 gap-2 h-screen overflow-auto">
          {/* <p className="bg-white">{roomStatus}</p> */}
          {/* <p className="bg-white">
            {momentNow().format("YYYY-MM-DD HH:mm:ss")}
          </p>
          <p className="bg-white">
            {utcToClientDatetime(
              dataSessionPduli?.session?.date,
              dataSessionPduli?.session?.startTime
            ).format("YYYY-MM-DD HH:mm:ss")}
          </p>
          <p className="bg-white">
            {isAfterFromServerGMT0(
              dataSessionPduli?.session?.date,
              dataSessionPduli?.session?.startTime
            )}
          </p> */}
          {dataValidationUser.data.typeUser == "Counselor" ? (
            <AssesseeInformationSesion />
          ) : (
            <KonselorInformationSession />
          )}
          <KonselingInformationSession />
          {dataValidationUser.data.typeUser == "Counselor" &&
            (roomStatus == "VC_ROOM" || roomStatus == "VC_CLOSE") && (
              <KesimpulanSaranSession />
            )}
        </div>
        <div className=" flex-initial bg-black h-screen aspect-[9/16] overflow-hidden relative">
          {/* {(dataSessionPduli?.session?.status == "Accepted" ||
            dataSessionPduli?.session?.status == "Active") &&
          roomStatus == VC_ROOM ? (
            <>
              }
            </>
          ) : (
            <VideoKonselingClose />
          )} */}
          {isWaitingRoom && (
            <VideoKonselingWatingOpen handleOpenRoom={() => handleOpenRoom()} />
          )}

          {isRoomClose && <VideoKonselingClose />}
          {isRoomOpen && (
            <VideoKonselingSession
              handleCLoseRoom={() => handleCLoseRoom()}
              handleCLoseRoomByServer={() => handleCLoseRoomByServer()}
              handleStartRecord={() => {
                handleStartRecord();
              }}
              handleReGetData={() => {
                // console.log("triger close VC: tahap 3");
                handleReGetData();
              }}
              forceClose={forceClose}
              handleForceCloseRoom={() => {
                handleForceCloseRoom();
              }}
            />
          )}
        </div>
        {dataSessionPduli?.dokumen != null &&
          dataSessionPduli?.dokumen != "" && (
            <OtherSecctionData data={{ dokumen: dataSessionPduli?.dokumen }} />
          )}
      </div>
    </>
  );
}
